// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__Bgg_8","detailsBorder":"styles_detailsBorder__g0Ovk"};